<template>
  <div class="panel-group-container">

    <div v-if="setbrandid === 'LAX'" class="lax-comp">
      <div class="lax-heading">Reasons to park with us</div>
      <div class="panel-group-lax">
        <div class="panel-lax">
          <img src="https://res.cloudinary.com/rezcomm2018/image/upload/v1737623342/brands/LAX/LAX_Flexible_Icon.png" alt="Flexibility">
          <div class="panel-lax-content">
            <p class="panel-lax-title">Flexibility</p>
            <p class="panel-lax-description">We allow you to change your reservation up to 2 hours before you fly.</p>
          </div>
        </div>
        <div class="panel-lax">
          <img src="https://res.cloudinary.com/rezcomm2018/image/upload/v1737623324/brands/LAX/LAX_No_Reservation_Fees_Icon.png" alt="No Reservation Fees">
          <div class="panel-lax-content">
            <p class="panel-lax-title">No Reservation Fees</p>
            <p class="panel-lax-description">The price you see is the price you'll pay. Taxes are included in the price you see.</p>
          </div>
        </div>
        <div class="panel-lax">
          <img src="https://res.cloudinary.com/rezcomm2018/image/upload/v1737623341/brands/LAX/LAX_Same_Day_Bookings_Icon.png" alt="Same Day Bookings">
          <div class="panel-lax-content">
            <p class="panel-lax-title">Same Day Bookings</p>
            <p class="panel-lax-description">We've got you covered for those last-minute trips.</p>
          </div>
        </div>
        <div class="panel-lax">
          <img src="https://res.cloudinary.com/rezcomm2018/image/upload/v1737623341/brands/LAX/LAX_Convenient_Icon.png" alt="Convenient">
          <div class="panel-lax-content">
            <p class="panel-lax-title">Convenient</p>
            <p class="panel-lax-description">You can't park any closer to the terminal.</p>
          </div>
        </div>
      </div>
    </div>



            <div v-if="setbrandid === 'SV1'" class="panel-group">
        

            <div class="panel-row panel-row-3"><div class="panel-inner"><div class="panel no-image" data-v-d32d57f8="" data-v-093122d0=""><div class="panel-data" data-v-d32d57f8=""><h3 data-v-d32d57f8=""></h3><p data-v-d32d57f8=""><!-- {{ panel_data.brief_description }} --></p><!--v-if--></div><div class="panel-image" data-v-d32d57f8=""><img style="width: 100%; max-height: 100%" src="https://res.cloudinary.com/rezcomm2018/image/upload/v1717682968/brands/SV1/homepage/summitshuttle_wide.jpg" data-v-d32d57f8=""></div></div></div></div>
            </div>


    <div v-if="setbrandid === 'LDY'" class="panel-group">
      <div class="panel-row panel-row-3">
        <div class="panel-inner">
          <div
            class="panel image-right"
          >
            <div class="panel-data" >
              <h3>Secure parking</h3>
              <p> 
                <span>
                The car park will be locked and secured during periods when the airport is closed.
                Airport opening times (please note, these times are subject to change):</span>
                <table>
                    <tbody><tr>
                        <td>
                        Monday - Friday
                        </td>
                        <td>
                        <b>&nbsp;&nbsp;&nbsp;05:00 - 22:15</b>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        Saturday
                        </td>
                        <td>
                        <b>&nbsp;&nbsp;&nbsp;05:00 - 18:00</b>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        Sunday
                        </td>
                        <td>
                        <b>&nbsp;&nbsp;&nbsp;07:00 - 22:15</b>
                        </td>
                    </tr>
                </tbody></table>
                <br>
                <span>Christmas Day <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Closed</b></span>
                <br>
                <span>New Year's Day <b>&nbsp;&nbsp;&nbsp;05:00 - 09:00</b> </span>
                <br>
                <br>
                <span style="margin-top: 15px;">If you require out of hours access to retrieve your vehicle (see airport opening times), 
                please contact the Airport Customer Services on: <a class="BF-marketing-link" target="_blank" href="tel:028 7181 3302">028 7181 3302</a> during normal operating hours,
                in advance where possible, and we will plan to accommodate your request.</span>
            </p>
            <br><br>
            <!-- <h3>Booking Updates & Cancellations</h3>
            <p> 
            <span>
              Please ensure all details provided within your booking are correct at the time of booking. Any amendments to your booking will require the cancellation of the booking and a new booking will have to be placed - a new booking can be made on this website or directly with our Parking team at City of Derry Airport: <a class="BF-marketing-link" target="_blank" href="tel:028 7181 3302">parking@cityofderryairport.com.</a>
              </span>
            </p> -->
            <br><br>
            </div>
          </div>
        </div>
      </div>
    </div>

     <div v-if="setbrandid === 'DRW'" class="drw-panel-group">
      <div class="drw-boxes-container">
        <div class="feature-box contactless">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751447417/brands/DRW/86e69158034e7bdb0eb791cac18a7a438677a8dc.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">Contactless</div>
            <div class="feature-description">
              Uses license plate recognition, so there is no need to take a ticket
              or make payment at a pay station.
            </div>
          </div>
        </div>
        <div class="feature-box value">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751447416/brands/DRW/a79bdfd136fc0f552798660ef514b04960ed51e5.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">
              Book online for our <br />best rates
            </div>
            <div class="feature-description">
              Pre-book online and obtain great discounts compared to our drive-up
              rates.
            </div>
          </div>
        </div>
        <div class="feature-box convenient">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751447416/brands/DRW/4d2fb8a2e53ba999cb2b6217c0082a0dc582e958.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">Convenient</div>
            <div class="feature-description">
              Conveniently located car parks offering a choice of parks that suit
              all budgets.
            </div>
          </div>
        </div>
        <div class="feature-box park-n-go">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751447416/brands/DRW/17f42820609e0bbec6dc9bf56adba1ed22a1dabd.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">Park 'n' Go</div>
            <div class="feature-description">
              Park just steps from the terminal and travel.
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="announcement-banner" v-if="setbrandid === 'PIT'">
      Any parking bookings made before 24 Oct 2024 that require a refund or new QR code issued please contact us at 412-472-5050 or PIT@lazparking.com for assistance.
    </div> -->
    <!-- <div v-if="setbrandid === 'PIT'" class="panel-group-pit">
      <img width="560" height="auto" style="width: 100%; height: auto" src="https://res.cloudinary.com/rezcomm2018/image/upload/v1729775861/brands/PIT/REZ_Home_Page_Products-Map.jpg"/>
    </div> -->

    <div class="panel-group" v-if="setbrandid !== 'SV1' && setbrandid !== 'LDY' && setbrandid !== 'PIT' && setbrandid !== 'NQY' && setbrandid !== 'DRW'">
      <div
        v-for="(panel_row, i) in panels_group"
        :key="panel_row.row"
        :class="`panel-row panel-row-${i}`"
      >
        <div class="panel-inner">
          <template v-for="panel in panel_row.columns" :key="panel.panelid">
            <Panel
              :panel_data="panel"
              :lang="lang.toUpperCase()"
              :translations="translations"
              :brandSlug="setbrandid"
            />
          </template>
        </div>
      </div>
    </div>

    <div v-if="setbrandid === 'NQY'" class='panel-group-nqy'>
      <img 
        style="width: 100%; height: auto;"
        class="waves" 
        src="https://res.cloudinary.com/rezcomm2018/image/upload/v1743686877/brands/NQY/illustration.png"
        alt="Waves"
      />

    </div>

    
  </div>
</template>

<script>
import Panel from "./Panel.vue";
export default {
  components: {
    Panel,
  },
  name: "PanelsGroup",
  props: {
    panels_group: undefined,
    lang: undefined,
    translations: undefined,
    setbrandid: undefined,
  },
};
</script>

<style scoped lang="scss">
.waves {
  position: relative;
  bottom: 0;
  left: 0;
}


// DRW Panel Group Styles
.drw-panel-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Fira Sans, -apple-system, Roboto, Helvetica, sans-serif;
  color: rgba(0, 61, 77, 1);
  text-align: center;
  justify-content: center;
  padding: 0;
  margin: 6rem auto;

  @media (max-width: 991px) {
    padding: 0 20px;
  }
}

.drw-boxes-container {
  display: flex;
  align-items: center;
  gap: 25px;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 991px) {
    max-width: 100%;
  }
}

.feature-box {
  align-items: center;
  border-radius: 8px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.25);
  align-self: stretch;
  display: flex;
  min-width: 240px;
  min-height: 284px;
  flex-direction: column;
  justify-content: flex-start;
  width: 294px;
  background-color: var(--WHITE, #fff);
  margin: auto 0;

  &.contactless {
    padding: 22px 16px 51px;
  }

  &.value {
    padding: 23px 16px;
  }

  &.convenient {
    padding: 22px 16px 47px;
  }

  &.park-n-go {
    padding: 22px 16px 69px;
  }
}

.feature-icon {
  object-fit: contain;
  object-position: center;
}

.contactless .feature-icon {
  aspect-ratio: 1.07;
  width: 73px;
}

.value .feature-icon {
  aspect-ratio: 1;
  width: 74px;
}

.convenient .feature-icon {
  aspect-ratio: 0.87;
  width: 63px;
}

.park-n-go .feature-icon {
  aspect-ratio: 0.93;
  width: 69px;
}

.feature-text {
  margin-top: 24px;
  max-width: 100%;
  width: 262px;
}

.feature-title {
  font-size: 24px;
  font-weight: 700;

  &:has(br) {
    line-height: 29px;
  }
}

.feature-description {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-top: 11px;
}

.panel-group-container {
  background-color: var(--panel-background-color);

  @media screen and (min-width: 768px) {
    margin-top: 3rem;
    padding: 3rem 0;
  }

  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
    padding: 1rem 0;
  }

  .panel {
    &-group {
      position: relative;
      // max-width: 1260px;
      margin: 0 auto;
      // padding: 3rem 0;
    }

    &-row {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      justify-content: center;

      padding: 0 1rem;

      // align-items: center;

      // @media screen and (max-width: 566.99px) {
      //   align-items: center;
      // }

      // @media screen and (min-width: 567px) {
      //   flex-direction: row;
      //   flex-wrap: wrap;
      // }

      // @media screen and (min-width: 960px) {
      //   flex-direction: row;
      //   flex-wrap: nowrap;
      // }
    }
  }

  .panel-group {
    gap: 1rem;
    display: flex;
    flex-direction: column;
    min-height: 320px;
  }

  .panel-inner {
    margin: 0 auto;
    max-width: 1280px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 1rem;
    justify-content: center;
    width: 100%;

    @media screen and (max-width: 566.99px) {
      align-items: center;
      flex-wrap: wrap;
    }

    @media screen and (min-width: 567px) {
      flex-direction: row;
      flex-wrap: wrap;
    }

    @media screen and (min-width: 960px) {
      flex-direction: row;
      flex-wrap: nowrap;
    }
  }
}
</style>

<style lang="scss">
// NWI Brand mods
.NWI {
  .panel-group-container {
    padding: 0;
    background: rgb(245, 245, 245);
    .panel-row-1 {
      padding: 3rem 0;
      @media screen and (max-width: 1320px) {
        padding: 3rem 1rem;
      }
      .panel.image-left {
        justify-content: flex-end;
      }
      .panel-image img {
        max-height: 220px;
      }
      .panel.image-right {
        max-width: 100%;
      }
    }
  }
}

// IP1 Brand mods
.IP1 {
  .panel-group-container {
    padding: 0;
    background: #fff;
    .panel-row-1 {
      background: rgb(245, 245, 245);
      padding: 3rem;
      .panel.image-left {
        justify-content: flex-end;
      }
      .panel-image img {
        max-height: 220px;
      }
    }
    .panel-row-2,
    .panel-row-3 {
      text-align: center;
      .panel.image-top {
        box-shadow: 0px 0px 0px #00000000;
      }
      .panel-image img {
        width: auto;
        max-height: 150px;
      }
      .panel-data {
        padding: 1rem;
      }
    }
    .panel-row-2 {
      padding-top: 3rem;
    }
    .panel-row-3 {
      padding-bottom: 3rem;
    }
  }
}

.PIT {
  .panel-group-container {
    padding: 0;
    background: #fff;
    
  }
}

.panel-group-pit {
  margin: 0 auto;
  margin-top: 1rem;
  max-width: 1320px;
  width: 100%;
  margin-bottom: 5rem;
  @media screen and (max-width: 786) {
    margin-top: 5rem;
    
  }
  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
    padding: 1rem 0;
    max-width: calc(100% - 2rem);
    margin-top: 10px;
  }
}
.panel-group-nqy {
  margin: 0 auto;
  width: 100%;
  background-color: #fff;
  @media screen and (max-width: 786) {
    margin-top: 5rem; 
  }
}

.announcement-banner {
  width: 100%;
  margin-top: -25px;
  background-color: #f5c6cb;
  color: #721c24;
  text-align: center;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media screen and (max-width: 1260px) {
    margin-top: 10px;
  }
}

.lax-comp{
  background-color: #f4f4f4;
  padding-top: 6rem;
  padding-bottom: 3rem;
}
.lax-heading {
  font-weight: bold;
  text-align: center;
  font-size: 28px;
}
.panel-group-lax {
  display: flex;
  max-width: 1300px;
  margin: auto;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}
@media screen and (min-width: 768px) {
  .panel-group-lax {
    padding: 4rem;
  }
  .panel-lax {
    flex: 1 0 48%;
  }
}
@media screen and (min-width: 1024px) {
  .panel-group-lax {
    padding: 1rem;
  }
  .panel-lax {
    flex: 1 0 22%;
  }
}
.panel-lax {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.panel-lax img {
  padding: 10px;
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.panel-lax-content {
  display: flex;
  margin-top: 10px;
  text-align: left;
  flex-direction: column;
  gap: 1;
  .panel-lax-title {
    font-weight: 700;
    color: #00A9CE;
    font-size: medium;
  }
  .panel-lax-description {
    font-size: small;
    max-width: 100%;
    letter-spacing: 0.04em;
    color: rgb(82, 87, 87)
  }
}

@import "@/assets/sass/override_brand.scss";
</style>
